module.exports = __webpack_public_path__ + "img/members-right-bsc.eae77d8e.png";